/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RefundReceiptDto } from '../../models/refund-receipt-dto';

export interface ReceiptControllerFindRefundById$Params {
  refundId: string;
}

export function receiptControllerFindRefundById(http: HttpClient, rootUrl: string, params: ReceiptControllerFindRefundById$Params, context?: HttpContext): Observable<StrictHttpResponse<RefundReceiptDto>> {
  const rb = new RequestBuilder(rootUrl, receiptControllerFindRefundById.PATH, 'get');
  if (params) {
    rb.query('refundId', params.refundId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<RefundReceiptDto>;
    })
  );
}

receiptControllerFindRefundById.PATH = '/api/receipt/refund';
